import { useSocialShares } from "@/hooks/useSocialShares";
import { PostNavigationProps } from "@/types/layout";
import { useRouter } from "next-translate-routes";
import Image from "next/image";
import React from "react";

export const PostNavigationSocialsButton: React.FC<PostNavigationProps> = ({ post }) => {
  const { shareOnTwitter, shareOnFacebook } = useSocialShares();

  const router = useRouter();

  const currentPath = router.asPath;

  return (
    <>
      <li className="w-full lg:w-[65px]">
        <button
          className="flex h-[38px] w-[38px] items-center justify-center rounded-full transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25"
          onClick={() => shareOnTwitter(post ? post.local_link : currentPath)}
        >
          <Image
            src="/assets/images/icons/twitter-new.svg"
            alt="Bookmark Button"
            width={20}
            height={20}
            className="dark:invert"
          />
        </button>
      </li>
      <li className="w-full lg:w-[65px]">
        <button
          className="flex h-[38px] w-[38px] items-center justify-center rounded-full transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25"
          onClick={() => shareOnFacebook(post ? post.local_link : currentPath)}
        >
          <Image
            src="/assets/images/icons/facebook-new.svg"
            alt="Bookmark Button"
            width={20}
            height={20}
            className="dark:invert"
          />
        </button>
      </li>
    </>
  );
};
